import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const championsReserveMetadata = {
  id: 'champions-reserve',
  name: 'Champions Reserve',
  description:
    'A purpose-built modern finale venue with spectator corridors, water, woodland and seven closing holes engineered for leaderboard swings.',
  environmentPreset: 'champions-reserve',
  metadata: {
    location: 'Victory Lake, Union',
    regionType: 'championship',
    difficulty: 93,
    typicalWind: [5, 16] as const,
    greenSpeed: [11.5, 12.5] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Balanced risk and restraint under season-finale pressure',
    signatureHoles: [4, 8, 12, 15, 16, 17, 18],
    tournamentEventId: 'event-20',
    previewTheme: 'navy-gold-finale',
    environmentPalette: {
      fairway: '#39704a',
      rough: '#254a38',
      bunker: '#dfcfaa',
      water: '#244d68',
      haze: '#9eacb6',
      sky: '#6689a4',
      rock: '#646b67',
    },
    vegetationStyle: 'polished woodland with broad spectator corridors',
    terrainStyle: terrainPreset('champions-reserve', 25, 125, 1.15).id,
    sunlightDirection: 'golden final-round afternoon',
    distantScenery: 'grandstands, broadcast towers and a navy-roofed clubhouse',
    waterStyle: 'deep blue championship lakes and creeks',
    eventPresentation: {
      accentColor: '#c6a75a',
      mark: 'TOURNAMENT GOLF',
      subtitle: 'Thirty players. One season title.',
      loadingCopy: 'The season comes down to this',
      identityLine: 'The purpose-built home of the season finale',
      tierLabel: 'SEASON CHAMPIONSHIP · TOP 30',
    },
  },
};
const pars = [4, 4, 3, 4, 4, 5, 4, 3, 4, 4, 3, 5, 4, 5, 4, 3, 5, 4],
  yards = [
    440, 455, 195, 330, 465, 585, 435, 225, 450, 430, 180, 565, 445, 470, 500, 165, 575, 485,
  ];
const names = [
  'Opening Ceremony',
  'Reserve Line',
  'Gold Stand',
  'Temptation',
  'Woodland Rise',
  'First Swing',
  'Arena',
  'Safe Side',
  'Turn Home',
  'Lake View',
  'Navy Tee',
  'Decision Water',
  'Broad Stage',
  'Pressure',
  'Championship Gate',
  'Volatility',
  'Anything Can Happen',
  'Final Word',
];
const o: Partial<HolePlan>[] = [];
o[3] = { water: 'green', splitFairway: true, greenRadius: 18 };
o[7] = { water: 'right', greenRadius: 22 };
o[11] = { water: 'right', splitFairway: true };
o[14] = { elevation: { tee: 8, landing: 0, green: 14 }, bunkerCount: 5 };
o[15] = { water: 'left', greenRadius: 15 };
o[16] = { water: 'right', splitFairway: true, bunkerCount: 5 };
o[17] = {
  water: 'carry',
  greenRadius: 23,
  bunkerCount: 4,
  landingZones: [{ distance: 290, width: 48, preferredSide: 'left' }],
};
export const createChampionsReserveDocument = () =>
  authorCourse({
    ...championsReserveMetadata,
    plans: plans(names, pars, yards, o).map((p) => ({ ...p, trees: p.trees ?? 6 })),
  });
